
import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ProductsPreview from './components/ProductsPreview';
import ProcessSection from './components/ProcessSection';
import CEEOfferSection from './components/CEEOfferSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { useSEO, generateOrganizationSchema, generateWebSiteSchema, generateWebPageSchema } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || '';
  
  const schemas = [
    generateOrganizationSchema(),
    generateWebSiteSchema(),
    generateWebPageSchema(
      'POWERENO - Rénovation LED Tertiaire Financée CEE',
      'POWERENO : spécialiste de la rénovation LED haute performance pour bâtiments tertiaires à Paris et en France. Financement CEE BAT-EQ-127, installation à partir de 1€.',
      siteUrl
    )
  ];

  useSEO({
    title: 'POWERENO - Rénovation LED Tertiaire Financée CEE | Économies jusqu\'à 75%',
    description: 'POWERENO : spécialiste de la rénovation LED haute performance pour bâtiments tertiaires à Paris et en France. Financement CEE BAT-EQ-127, installation à partir de 1€. Économies d\'énergie jusqu\'à 75%, luminaires 185 lm/W, garantie 5 ans.',
    keywords: 'rénovation LED, éclairage tertiaire, CEE BAT-EQ-127, économies énergie, luminaires LED professionnels',
    canonical: siteUrl,
    schema: schemas
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <StatsSection />
      <ProductsPreview />
      <ProcessSection />
      <CEEOfferSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
      <FloatingCTA />
    </div>
  );
}
